import { useCallback, useState } from 'react'

export function useBoolean(initialValue: boolean): [boolean, (newValue?: unknown) => void, () => void] {
  const [bool, setBool] = useState(initialValue)
  const update = useCallback((newValue?: unknown) => {
    if (typeof newValue === 'boolean') {
      setBool(newValue)
    } else {
      setBool(true)
    }
  }, [])
  const setToFalse = useCallback(() => update(false), [update])
  return [bool, update, setToFalse]
}
